module.exports = __webpack_public_path__ + "static/media/006-thinking.39d8e3e5.svg";